import React from 'react';
import { IBuyBackProduct } from 'components/BuyBack/interfaces/buyBackInterfaces';
import { useMutation } from 'redux-query-react';
import { useDispatch } from 'react-redux';
import { formatPrice } from '../../../helpers/priceFormatHelper';
import BuyBackModal from 'components/BuyBack/BuyBackModal';
import { openOverlay } from 'data/overlays/overlayHandler';
import getBuyBackProductsRequest from 'components/BuyBack/requests/getBuyBackProductsRequest';
import addBuyBackProductsRequest from 'components/BuyBack/requests/addBuyBackProductsRequest';
import useBuyBackCartConfig from 'components/Cart/Hooks/useBuyBackCartConfig';

interface IProps {
    buyBackProducts: IBuyBackProduct[];
    setBuyBackProducts: (buyBackProducts: IBuyBackProduct[]) => void;
    resetBuyBackProducts: () => void;
}

const BuyBackProduct = (props: IProps) => {
    const { buyBackProducts, setBuyBackProducts, resetBuyBackProducts } = props;

    const { buyBackConfig } = useBuyBackCartConfig();
    const dispatch = useDispatch();

    const [{}, addBuyBackProducts] = useMutation((devices: IBuyBackProduct[]) =>
        addBuyBackProductsRequest({ devices }),
    );
    const [{}, queryBuyBackProducts] = useMutation(() => getBuyBackProductsRequest());

    const getBuyBackTotalValue = (): number => {
        let totalValue = 0;

        buyBackProducts.forEach((buyBackProduct) => {
            totalValue += buyBackProduct.model_price;
        });

        return totalValue;
    };

    if (!buyBackConfig) {
        return null;
    }

    const { cartConfig, modalConfig } = buyBackConfig;

    return (
        <>
            <tr>
                <td className="cart-table-image">
                    <a href="#">
                        <span className="image">
                            <img src={cartConfig.imageUrl} alt={cartConfig.labels.buyBackProduct} />
                        </span>
                    </a>
                </td>
                <td>
                    <p className="cart-table-title">
                        <a href="#">{cartConfig.labels.buyBackProduct}</a>
                    </p>
                    <ul className="cart-table-specs wide">
                        {buyBackProducts.map((buyBackProduct) => {
                            return (
                                <li key={buyBackProduct.model_name}>
                                    <span className="label">{buyBackProduct.model_name}:</span>
                                    <span className="value">
                                        {formatPrice(buyBackProduct.model_price.toString(), true)}
                                    </span>
                                </li>
                            );
                        })}
                    </ul>
                </td>
                <td>
                    <ul className="cart-table-price">
                        <li>
                            <span className="label">{cartConfig.labels.quantity}</span>
                            <span className="value">
                                <span className="number">1</span>
                            </span>
                        </li>
                        <li className="total" aria-live="polite">
                            <span className="label">{cartConfig.labels.total}</span>
                            <span className="value sum">-{formatPrice(getBuyBackTotalValue().toString(), true)}</span>
                        </li>
                    </ul>
                    <p className="cart-table-remove">
                        <a
                            href="#"
                            onClick={() => {
                                dispatch(openOverlay({ name: 'buyBack' }));
                            }}
                        >
                            {cartConfig.labels.changeBuyBack}
                        </a>
                    </p>
                </td>
                <BuyBackModal
                    config={modalConfig}
                    buyBackProducts={buyBackProducts.map((buyBackProduct) => {
                        buyBackProduct.unique_id = `${buyBackProduct.model_id}${Math.random()}`;
                        return buyBackProduct;
                    })}
                    setBuyBackProducts={setBuyBackProducts}
                    saveCallback={(newBuyBackProducts) => {
                        void addBuyBackProducts(newBuyBackProducts).then(() => {
                            void queryBuyBackProducts();
                        });
                    }}
                    resetCallBack={resetBuyBackProducts}
                />
            </tr>
        </>
    );
};

export default BuyBackProduct;
